import ModalClearCash from './ModalClearCash.jsx';

export default ModalClearCash;